namespace RioERP.Wallet {
    export interface CreditWalletForm {
        JournalId: Serenity.LookupEditor;
        AssetTypeId: Serenity.IntegerEditor;
        Credits: Serenity.IntegerEditor;
        CreditBalance: Serenity.IntegerEditor;
        TransactionId: Serenity.IntegerEditor;
        TransactionDate: Serenity.DateEditor;
        TransactionDetails: Serenity.StringEditor;
        TransactionNo: Serenity.StringEditor;
        FranchiseeId: Serenity.LookupEditor;
    }

    export class CreditWalletForm extends Serenity.PrefixedContext {
        static formKey = 'Wallet.CreditWallet';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CreditWalletForm.init)  {
                CreditWalletForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.StringEditor;

                Q.initFormType(CreditWalletForm, [
                    'JournalId', w0,
                    'AssetTypeId', w1,
                    'Credits', w1,
                    'CreditBalance', w1,
                    'TransactionId', w1,
                    'TransactionDate', w2,
                    'TransactionDetails', w3,
                    'TransactionNo', w3,
                    'FranchiseeId', w0
                ]);
            }
        }
    }
}
